module.exports = __webpack_public_path__ + "assets/img/btn_TapTap-7e5b3c3b.png";